import {
  Component,
  OnInit,
  Directive,
  ElementRef,
  Input,
  HostListener
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DomSanitizer } from "@angular/platform-browser";
import { DataService } from "../../services/data.service"
import { InProductsService } from "../../services/inventory/in-products.service";
import { InToolsService } from "../../services/inventory/in-tools.service";
import { AuthenticationService } from "../../services/authentication.service";
import { environment } from "../../../../environments/environment";
import { forEach } from "@angular/router/src/utils/collection";

export interface PrintItems {
  title: string;
  Items: any;

}

@Component({
  selector: 'app-pricechange',
  templateUrl: './pricechange.component.html',
  styleUrls: ['./pricechange.component.css']
})
export class PriceChangeComponent extends DialogComponent<PrintItems, boolean>
  implements PrintItems, OnInit {

  title: string;
  Items: any;
  Cols: any;
  href: string = "";
  Remark: string = "";
  scollable: boolean = false;
  barcode: string = ""
  cate: string = ""
  result: any = { result: false, RtnItem: {} };
  @Input() popup: boolean = true;
  // isLoaded: boolean = true;
  loading: boolean = false


  Access: any;
  Columns: any;
  ItemName: string = ""
  Barcode: string = ""
  isedit: boolean = false;
  model = new PriceChange_Master();
  PriceChageList: PriceChange_Master[] = [];

  constructor(dialogService: DialogService, private sanitizer: DomSanitizer, private ds: DataService,
    private ips: InProductsService, private aut: AuthenticationService, private ts: InToolsService) {
    super(dialogService);
  }

  ngOnInit() {
    // this.ds.ComponentName = "Price Change";
    this.Access = this.ds.Access["Price Change"];
    this.clear();
    this.Columns = [
      { field: 'Barcode', header: 'Barcode', t: 'text', f: 'input' },
      { field: 'ItemName', header: 'Item Name', t: 'text', f: 'input' },
      { field: 'Unit', header: 'Unit', t: 'text', f: 'input' },
      { field: 'Contain', header: 'Contain', t: 'text', f: 'input' },
      { field: 'CostPrice', header: 'Cost Price', t: 'decimal', f: 'decimal', e: true },
      { field: 'SellingPrice', header: 'Selling Price', t: 'decimal', f: 'decimal', e: true }
    ];
    this.Barcode = this.Items.Barcode;
    this.ItemName = this.Items.ItemName;
    if (this.Barcode != "" && this.popup) {
      this.Get_ItemForPriceChange();
    }
  }

  clear() {
    this.model = new PriceChange_Master();
    this.PriceChageList = [];
    this.isedit = false;
  }

  barcodeKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.Get_ItemForPriceChange();
    }
  }

  Get_ItemForPriceChange() {
    this.PriceChageList = [];
    this.loading = true;
    var data = {
      Barcode: this.Barcode,
      BranchId: this.ds.Settings.BranchId,
      SellingPriceLevelid: this.ds.Settings.SellingPriceLevelId
    }

    this.ts.Get_ItemForPriceChange(data).subscribe(res => {
      if (res.Success) {
        this.PriceChageList = res.data;
        this.loading = false;
      }
      else {
        this.PriceChageList = [];
        this.loading = false;
      }
    })
  }

  validateItem(): boolean {
    for (let i of this.PriceChageList) {
      if (i.Barcode == "") {
        alert("Barcode Empty");
        return false;
      }
      i.CompanyId = this.ds.Settings.CompanyId;
      i.BranchId = this.ds.Settings.BranchId;
      i.SellingPriceLevelId = this.ds.Settings.SellingPriceLevelId;
      i.ItemMasterTypeId = this.ds.Settings.ItemTypeId;
    }
    return true;
  }

  updateItem() {
    var r = confirm("Do you want to update this Price?")
    if (r) {
      if (this.validateItem()) {
        this.loading = true;
        this.ts.Update_ItemPrice(this.PriceChageList).subscribe(res => {
          if (res.Success) {
            alert("Price updated Successfully");
            this.clear();
            this.loading = false;
            this.result.result = true;
            this.result.RtnItem = res.data;
            this.close();
          }
          else {
            alert(res.error.UsrMsg);
            this.loading = false;
            this.result.result = false;
            this.result.RtnItem = this.Items;
            this.close();
          }
        });
      }

    }
  }

  saveEditAccessPremission(Access: any): boolean {
    Access = this.ds.Access["Price Change"];
    // if (edit) {
    //   return !Access.edit
    // }
    // else {
    if (Access == undefined) {
      return false
    }
    return !Access.save
    // }
  }


}
class PriceChange_Master {
  Id: number = 0;
  Barcode: string = "";
  ItemName: string = "";
  Unit: string = "";
  Contain: string = "";
  CostPrice: number = 0;
  SellingPrice: number = 0;
  UserId: number = 0;
  BranchId: number = 0;
  CompanyId: number = 0;
  SellingPriceLevelId: number = 0;
  ItemMasterTypeId: number = 0;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/pricechange/pricechange.component.ts